"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgEyeOpen = function (_a) {
    var primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, tertiaryColor = _a.tertiaryColor, props = __rest(_a, ["primaryColor", "secondaryColor", "tertiaryColor"]);
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 16 12" }, props),
        react_1.default.createElement("path", { stroke: primaryColor, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: 0.95, d: "M14.722 5.187C14.901 5.41 15 5.7 15 6c0 .3-.099.59-.278.813C13.59 8.185 11.01 10.855 8 10.855c-3.01 0-5.59-2.67-6.722-4.042A1.303 1.303 0 0 1 1 6c0-.3.1-.59.278-.813C2.411 3.815 4.99 1.145 8 1.145c3.01 0 5.59 2.67 6.722 4.042Z" }),
        react_1.default.createElement("path", { stroke: primaryColor, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: 0.95, d: "M8 8.158a2.158 2.158 0 1 0 0-4.316 2.158 2.158 0 0 0 0 4.316Z" })));
};
exports.default = SvgEyeOpen;
